import { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import "./style.scss";
import LocationFinder from "../locationFinder";
import MGAAPI from "../../api/index";
import ApiSession from "../../api/index";
import displayError from "../../constants/utils";
import {
  flattenCountComponentDTOList,
  flattenDesignCountComponent,
  projectDetailsAtom,
} from "../../utils/atoms/projectDetailsAtom";
import { useAtom } from "jotai";
import { userScopeAtom } from "../../utils/atoms/userScopeAtom";
import { getRandomInt } from "../../Tarrif/TarifUtils";
import { Drawer, Group } from "@mantine/core";
import { locationAllDTOAtom } from "../../utils/atoms/locationAllDTOAtom";
import { isAnyVersionCompleted } from "../../constants/helper";

const apiSession = new ApiSession();
const MGAAPIS = new MGAAPI();

const EditProjectDetails = ({
  isEditVisible,
  toggleEditDetails,
  projectDetails,
}) => {
  const { t } = useTranslation();
  const [locationAllDTO] = useAtom(locationAllDTOAtom);
  const [locationDTO, setLocationData] = useState(projectDetails.locationDTO);
  const [projectDTO, setProjectDTO] = useState(projectDetails.projectDTO);
  const locationCallback = (data) => {
    setLocationData(data);
  };
  const [currencyList, setCurrencyList] = useState([]);
  const [renderLocationComponent] = useState(true);
  const [loading, setLoading] = useState(false);
  const LANGUAGE = "en";
  const CUSTOM_LABELS = LocationFinder.getLabelsForLanguage(LANGUAGE);
  const locationRef = useRef(null);
  const [projectDetailsedit, setProjectDetails] = useAtom(projectDetailsAtom);
  const [userScope] = useAtom(userScopeAtom);


  const getCurrencyList = () => {
    apiSession
      .getDefaultInfo()
      .then((json) => {
        json.sort((a, b) => a.status.localeCompare(b.status));
        setCurrencyList(json);
      })
      .catch(() => {});
  };
  useEffect(() => {
    getCurrencyList();
  }, []);

  useEffect(() => {
    setLocationData(projectDetails.locationDTO);
    setProjectDTO(projectDetails.projectDTO);
  }, [projectDetails]);

  const updateProjectModalHandler = () => {
    const validation = LocationFinder.validateLocation(
      locationDTO?.locationINData || locationAllDTO?.locationINData,
      locationDTO?.projectData?.projectName
        ? locationDTO?.projectData
        : locationAllDTO?.projectData
    );
    if (validation) {
      return;
    } else {
      const locationDTODetails = {
        projectId:
          locationDTO?.projectData?.projectId ??
          projectDetailsedit?.projectDTO?.projectId,
        locationId: projectDetails.locationDTO.locationId,
        address: locationDTO?.locationINData?.address,
        city: locationDTO?.locationINData?.city,
        zipCode: locationDTO?.locationINData?.zipCode,
        state: locationDTO?.locationINData?.stateProvince,
        country: locationDTO?.locationINData?.country,
        latitude: locationDTO?.locationINData?.latitude,
        longitude: locationDTO?.locationINData?.longitude,
      };
      const payload = {
        projectId:
          locationDTO?.projectData?.projectId ??
          projectDetailsedit?.projectDTO?.projectId,
        projectName:
          locationDTO?.projectData?.projectName ||
          locationAllDTO?.projectData?.projectName,
        projectNumber: `0001${getRandomInt(21, 9999)}`,
        createdBy: locationDTO?.projectData?.createdBy,
        createdOn: locationDTO?.projectData?.createdOn,
        updatedOn: locationDTO?.projectData?.createdOn,
        updatedBy: locationDTO?.projectData?.createdBy,
        customerName:
          locationDTO?.projectData?.customerName ||
          locationAllDTO?.projectData?.customerName,
        projectDescription:
          locationDTO?.projectData?.projectDescription ||
          locationAllDTO?.projectData?.projectDescription,
        currency:
          locationDTO?.projectData?.currency ||
          locationAllDTO?.projectData?.currency,
        projectType: "ANSI",
        locationDTO: locationDTODetails,
        projectStatus: "INPROGRESS",
        currencyCode:
          locationDTO?.projectData?.currencyCode ||
          locationAllDTO?.projectData?.currencyCode,
        dateFormat:
          locationDTO?.projectData?.dateFormat ||
          locationAllDTO?.projectData?.dateFormat,
        numberFormat:
          locationDTO?.projectData?.numberFormat ||
          locationAllDTO?.projectData?.numberFormat,
      };
      setLoading(true);
      MGAAPIS.createProject(payload)
        .then(async (resp) => {
          setLoading(false);
          MGAAPIS.editProject(resp.projectId).then((res) => {
            setProjectDetails((prev) => ({
              ...prev,
              userId: res.userId || "",
              currencyCode: res?.projectDTO?.currencyCode || "$",
              projectDTO: res.projectDTO || {},
              componentDTOList:
                flattenCountComponentDTOList(res.countComponentDTOList) || [],
              designWithVersionsDTOList: res.designWithVersionsDTOList || [],
              locationDTO: res.locationDTO || {},

            }));
          });

          toggleEditDetails();
          displayError("success", t("projectDetails.updated"));
        })
        .catch((error) => {
          toggleEditDetails();
          setLoading(false);

          displayError("error", error.message);
        });
    }
  };

  const handleCancel = () => {
    toggleEditDetails();
    setLocationData(projectDetails.locationDTO);
    setProjectDTO(projectDetails.projectDTO);
  };

  if (loading) {
    return <se-loading loading={loading} />;
  }
  return (
    <Drawer.Root opened={isEditVisible} onClose={toggleEditDetails} size="90%" position="left" transitionProps={{ transition: 'slide-right', duration: 300, timingFunction: 'ease' }}>
      <Drawer.Overlay />
      <Drawer.Content style={{ height: '100vh' }}>
        <Drawer.Header style={{ borderBottom: "2px #3dcd58 solid" }}>
          <span className="se-dialog-custom-header project-modal-title">
            {t('projectDetails')}
          </span>
          <Group>
            <se-button
              aria-label="edit-project-cancel"
              option="raised"
              style={{ marginLeft: "auto" }}
              disabled={false}
              onClick={handleCancel}
            >
              {t('common.cancel')}
            </se-button>
            <se-button
              aria-label="edit-project-save"
              option="raised"
              color="primary"
              style={{ marginLeft: "auto" }}
              disabled={
                
                !(userScope && userScope.access && userScope.access.createOrUpdateProject)
              }
              onClick={updateProjectModalHandler}
            >
              {t('common.save')}
            </se-button>
          </Group>
        </Drawer.Header>
        <div style={{ padding: "2rem" }}>
          {renderLocationComponent && (
            <LocationFinder
              customLabels={CUSTOM_LABELS}
              locationData={locationDTO}
              projectDTO={projectDTO}
              locationDataCallback={locationCallback}
              ref={locationRef}
              mandatoryMsgDisplay={true}
              currencyList={currencyList}
            />
          )}
        </div>
      </Drawer.Content>
    </Drawer.Root>
  );
};
export default EditProjectDetails;
